import { URL_API_BASE } from '../constant'
import {checkUser, outLogin, removeUser} from '../util/login'
import axios from 'axios'
import qs from 'qs'

import {Message, MessageBox} from 'element-ui'
const NOT_OPEN_ROUTER_LIST = ['/data_model_edit', '/data_import', '/data_view_algorithm_edit'];

axios.defaults.baseURL = URL_API_BASE
axios.defaults.timeout = 60000
axios.defaults.retry = 1
axios.defaults.retryDelay = 10000
axios.defaults.withCredentials = true

let cookie = document.cookie.match(new RegExp(`XSRF-TOKEN=([^;]+)`))
const CSRF_TOKEN = cookie == null ? null : cookie[1]
if (CSRF_TOKEN) {
    axios.defaults.headers.common['X-XSRF-TOKEN'] = CSRF_TOKEN
}

axios.interceptors.request.use(config => {
    //TODO http headers验证
    return config
}, error => {
    return Promise.reject(error)
})

axios.interceptors.response.use(response => {
    return response
}, err => {
    let config = err.config
    if (!config || !config.retry) return Promise.reject(err)
    config.__retryCount = config.__retryCount || 0
    if (config.__retryCount >= config.retry) {
        if (err.message === 'Network Error') {
            // TODO 提示网络不可用，请检查你的网络设置
        }
        return Promise.reject(err)
    }
    config.__retryCount += 1
    let backoff = new Promise(resolve => {
        setTimeout(() => {
            resolve()
        }, config.retryDelay || 1)
    })
    return backoff.then(() => {
        return axios(config)
    })
})

let is_confirm = true

export default {
    get (url, params, is_logon = true) {
        let user = {};
        if (is_logon) {
            user = checkUser(is_logon) || {};
        }
        return new Promise((resolve, reject) => {
            axios.get(url, {
                params: params, paramsSerializer: params => { return qs.stringify(params, { indices: false }) },
                headers: { 'x-token': user.token,"path":window.location.pathname }
            },)
                .then(response => {
                    if (response.data.code == '-1') {
                        this.openLogin(user)
                        // outLogin()
                    }
                    // if (response.data.error) {
                    //     return
                    // }
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    stream (url, params, is_logon = true) {
        let user = {};
        if (is_logon) {
            user = checkUser(is_logon) || {};
        }
        return new Promise((resolve, reject) => {
            axios.get(url, {
                params: params, paramsSerializer: params => { return qs.stringify(params, { indices: false }) },
                headers: { 'x-token': user.token },
                responseType: 'stream' // 将响应数据作为可读流返回
            },)
                .then(response => {
                    //console.log(response)
                    if (response.data.code == '-1') {
                        this.openLogin(user)
                        // outLogin()
                    }
                    // if (response.data.error) {
                    //     return
                    // }
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    post (url, params, is_logon = true,config) {
        let user = {};
        if (is_logon) {
            user = checkUser(is_logon) || {};
        }
        return new Promise((resolve, reject) => {
            axios.post(url, params, { headers: { "x-token": user.token ,"path":window.location.pathname} ,baseURL:  config?.baseURL ?? URL_API_BASE ?? '',})
                .then(response => {
                    if (response.data.code == '-1') {
                        this.openLogin(user)
                    }
                    // if (response.data.error) {
                    //     // TODO 提示API请求失败
                    //     return
                    // }
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    postForm (url, params,is_logon = true,) {
        let user = {};
        if (is_logon) {
            user = checkUser(is_logon) || {};
        }
        return new Promise((resolve, reject) => {
            axios.post(url, qs.stringify(params), { headers: { "x-token": user.token } })
                .then(response => {
                    if (response.data.code == '-1') {
                        this.openLogin(user)
                    }
                    // if (response.data.error) {
                    //     // TODO 提示API请求失败
                    //     return
                    // }
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    put (url, params) {
        let user = checkUser(true) || {};
        return new Promise((resolve, reject) => {
            axios.put(url, params, { headers: { "x-token": user.token } })
                .then(response => {
                    if (response.data.code == '-1') {
                        this.openLogin(user)
                    }
                    if (response.data.error) {
                        // TODO 提示API请求失败
                        return
                    }
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    delete (url, params) {
        let user = checkUser(true) || {};
        return new Promise((resolve, reject) => {
            axios.delete(url, { params: params, headers: { "x-token": user.token }, paramsSerializer: params => { return qs.stringify(params, { indices: false }) } })
                .then(response => {
                    if (response.data.code == '-1') {
                        this.openLogin(user)
                    }
                    if (response.data.error) {
                        // TODO 提示API请求失败
                        return
                    }
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    openLogin(user){
        let pathname = location.pathname;
        //console.log(is_confirm, pathname, user);
        if(is_confirm){
            if (Object.keys(user).length > 0 && NOT_OPEN_ROUTER_LIST.indexOf(pathname) > -1){
                //console.log('您的登录已过期, 请跳转登录?');
                MessageBox.confirm('您的登录已过期, 请跳转登录?', '提示', {
                    confirmButtonText: '登录',
                    cancelButtonText: '关闭',
                    type: 'warning'
                }).then(() => {
                    is_confirm = false
                    let url = '/login';
                    removeUser()
                    window.open(url)
                }).catch(() => {
                    Message({
                        type: 'error',
                        message: '登录失效',
                        center: true
                    });
                });
            } else {
                //outLogin()
                // Message({
                //     type: 'error',
                //     message: '登录失效，请重新登录!',
                //     center: true
                // });
                removeUser()
                location.href = '/login'
            }
        }
    }
}
